import React, {useState, useEffect} from 'react';
import Stylesheet from './Notifications.module.css';
import {AppContext} from '../../../contexts/app';
import Button from '../../../elements/Button/Button';
import { ico_bell, ico_bell_slash } from '../../../icon';
import Notification from '../../../components/Notification/Notification';
import Loading from '../../../components/Spinner/Standard/Standard';

const Notifications = (props) => {
    let app = null;
    const [collection, setCollection] = useState(null);
    const init = (appContext) => {
        app = appContext;
    }
    useEffect(() => {
        setCollection(app?.notifications);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])
    const header = () => {
        return (
            <div className={Stylesheet.Header}>
                <h3>{ico_bell}&emsp;notifications</h3>
                <Button secondary disabled={!collection || collection.length === 0}
                onClick={_ => setCollection([])}>{ico_bell}&emsp;clear all</Button>
            </div>
        )
    }
    const content = () => {
        if (!collection)
        return (
            <div className={Stylesheet.Loading}>
                <Loading show={true} />
            </div>
        )
        if (collection.length === 0) 
        return (
            <div className={Stylesheet.NoNotifications}>
                <h1>{ico_bell_slash}</h1>
                <h3>no notifications to show yet, once one arrives it will show up here.</h3>
            </div>
        )
        return (
            <React.Fragment>
                {collection.map((value, index) => (
                    <Notification user={app.profile} key={index} metadata={value} />
                ))}
            </React.Fragment>
        )
    }

    return (
       <AppContext.Consumer>
           {app => (
                <div className={Stylesheet.Container}>
                    {init(app)}
                    {header()}
                    {content()}
                </div>
           )}
       </AppContext.Consumer>
    )
}

export default Notifications;